import type { XandrKeywords } from '../types';
import { prepareXandrKeywords } from '../prepareKeywords';

import { getGlobalKeywords } from './keywords';
import {
  buildRequestKeywords,
  RequestKeywordsParams,
} from './buildRequestKeywords';

// Single source of request-level ad keywords shared by the classic ADN
// settings path and the VMAP path for the Swedish (Aftonbladet/SvD) brands.
// Both paths emit `kw_`-prefixed Xandr keywords only. `includeTcfConsent`
// (default `true`) toggles the tcf/gdpr consent keywords; the VMAP path
// (`getVmapKeywords`) sets it to `false`.
export async function getRequestKeywords(
  params: RequestKeywordsParams & { includeTcfConsent?: boolean }
): Promise<XandrKeywords> {
  const { includeTcfConsent = true, ...requestParams } = params;

  const keywords = await buildRequestKeywords({
    ...requestParams,
    buildGlobalKeywords: (
      keywords,
      asset,
      deviceType,
      cmpConsent,
      dynamicAR,
      player,
      siteConfig
    ) =>
      getGlobalKeywords(
        keywords,
        asset,
        deviceType,
        cmpConsent,
        dynamicAR,
        player,
        siteConfig,
        { includeTcfConsent }
      ),
  });

  return prepareXandrKeywords(keywords);
}
